import { decodeHexResponse } from '../_common/common.utils';
import {
	MONTHLY_CHECKOUT_START,
	MONTHLY_CHECKOUT_SUCCESS,
	MONTHLY_CHECKOUT_FAILURE,
	MONTHLY_CHECKOUT_RESET,
	MONTHLY_CHECKOUT_RESPONSE_CHANGED,
	MONTHLY_CHECKOUT_RESPONSE_REST_START,
	MONTHLY_CHECKOUT_DETAILS_START,
	MONTHLY_CHECKOUT_DETAILS_SUCCESS,
	MONTHLY_CHECKOUT_DETAILS_FAILURE,
} from './MonthlyCheckout.types';

const INITIAL_STATE = {
	monthlyCheckoutResponse: null,
	monthlyCheckoutDetailsResponse: null,
	isLoading: false,
	isDetailsLoading: false,
	error: null,
	detailsError: null,
};

const monthlyCheckoutReducer = (state = INITIAL_STATE, action: any) => {
	switch (action.type) {
		case MONTHLY_CHECKOUT_START:
			return { ...state, monthlyCheckoutResponse: null, isLoading: true, error: null };
		case MONTHLY_CHECKOUT_SUCCESS:
			return { ...state, 
				monthlyCheckoutResponse:decodeHexResponse (action.payload,"getMonthlyCheckoutKey"), isLoading: false, error: null };
		case MONTHLY_CHECKOUT_FAILURE:
			return { ...state,  
				monthlyCheckoutResponse:decodeHexResponse (action.payload,"getMonthlyCheckoutKey"), isLoading: false, error: action.payload };
		case MONTHLY_CHECKOUT_RESET:
			return { ...state, monthlyCheckoutResponse: null };
		case MONTHLY_CHECKOUT_RESPONSE_CHANGED:
			return { ...state, monthlyCheckoutResponse: null };
		case MONTHLY_CHECKOUT_RESPONSE_REST_START:
			return { ...state, monthlyCheckoutResponse: null };
		case MONTHLY_CHECKOUT_DETAILS_START:
			return { ...state, monthlyCheckoutDetailsResponse: null, isDetailsLoading: true, detailsError: null };
		case MONTHLY_CHECKOUT_DETAILS_SUCCESS:
			return { ...state, 
				monthlyCheckoutDetailsResponse: decodeHexResponse(action.payload,"getMonthlyCheckoutDetailsKey"), isDetailsLoading: false, detailsError: null };
		case MONTHLY_CHECKOUT_DETAILS_FAILURE:
			return { ...state, monthlyCheckoutDetailsResponse: null, isDetailsLoading: false, detailsError: action.payload };
		default:
			return state;
	}
};

export default monthlyCheckoutReducer;
